import Appointments from '@/admin/pages/appointments/appointments';
import { appointmentsQuery } from '@/admin/queries/appointments';
import { parseDate, parseEnum, sanitizeSearchParams } from '@/lib/utils';
import { createFileRoute } from '@tanstack/react-router';

const APPOINTMENT_STATUSES = [
	'scheduled',
	'completed',
	'cancelled',
	'no_show',
] as const;

export const Route = createFileRoute('/_app/appointments/')({
	validateSearch: (search) =>
		sanitizeSearchParams(search, (r) => ({
			status: parseEnum<(typeof APPOINTMENT_STATUSES)[number]>(
				r.status,
				APPOINTMENT_STATUSES,
			),
			from_date: parseDate(r.from_date),
			to_date: parseDate(r.to_date),
		})),

	loaderDeps: ({ search }) => search,

	loader: ({ context, deps }) =>
		context.queryClient.ensureQueryData(
			appointmentsQuery({
				page: deps.page,
				per_page: deps.per_page,
				search: deps.search || undefined,
				status: deps.status,
				from_date: deps.from_date,
				to_date: deps.to_date,
			}),
		),

	component: Appointments,
});
